import createIcon from '../../createIcon';

/**
 * @component @name ManageSearch
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyA4LjVIMlY2LjVIN1Y4LjVaTTcgMTEuNUgyVjEzLjVIN1YxMS41Wk0yMC41OSAxOC41TDE2Ljc2IDE0LjY3QzE1Ljk2IDE1LjE5IDE1LjAyIDE1LjUgMTQgMTUuNUMxMS4yNCAxNS41IDkgMTMuMjYgOSAxMC41QzkgNy43NCAxMS4yNCA1LjUgMTQgNS41QzE2Ljc2IDUuNSAxOSA3Ljc0IDE5IDEwLjVDMTkgMTEuNTIgMTguNjkgMTIuNDYgMTguMTcgMTMuMjVMMjIgMTcuMDlMMjAuNTkgMTguNVpNMTcgMTAuNUMxNyA4Ljg1IDE1LjY1IDcuNSAxNCA3LjVDMTIuMzUgNy41IDExIDguODUgMTEgMTAuNUMxMSAxMi4xNSAxMi4zNSAxMy41IDE0IDEzLjVDMTUuNjUgMTMuNSAxNyAxMi4xNSAxNyAxMC41Wk0yIDE4LjVIMTJWMTYuNUgyVjE4LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ManageSearch = createIcon('ManageSearch', [
  [
    'path',
    {
      d: 'M7 8.5H2V6.5H7V8.5ZM7 11.5H2V13.5H7V11.5ZM20.59 18.5L16.76 14.67C15.96 15.19 15.02 15.5 14 15.5C11.24 15.5 9 13.26 9 10.5C9 7.74 11.24 5.5 14 5.5C16.76 5.5 19 7.74 19 10.5C19 11.52 18.69 12.46 18.17 13.25L22 17.09L20.59 18.5ZM17 10.5C17 8.85 15.65 7.5 14 7.5C12.35 7.5 11 8.85 11 10.5C11 12.15 12.35 13.5 14 13.5C15.65 13.5 17 12.15 17 10.5ZM2 18.5H12V16.5H2V18.5Z',
      key: 'dwbr4g',
    },
  ],
]);

export default ManageSearch;
